"use strict";
// Copyright © 2021 Move Closer
Object.defineProperty(exports, "__esModule", { value: true });
exports.LayoutSlot = exports.LayoutContainerType = exports.LayoutContainer = exports.ContentType = void 0;
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 * @author Krzysztof Ustowski <krzysztof.ustowski@movecloser.pl>
 * @author Michał Wawer <michal.wawer@movecloser.pl>
 */
var ContentType;
(function (ContentType) {
    ContentType["Article"] = "article";
    ContentType["Landing"] = "landing";
    ContentType["LiveArticle"] = "live_article";
    ContentType["Page"] = "page";
    ContentType["SmartPage"] = "smart_page";
})(ContentType = exports.ContentType || (exports.ContentType = {}));
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
var LayoutContainer;
(function (LayoutContainer) {
    LayoutContainer["Bottom"] = "bottom";
    LayoutContainer["Middle"] = "middle";
    LayoutContainer["Top"] = "top";
})(LayoutContainer = exports.LayoutContainer || (exports.LayoutContainer = {}));
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
var LayoutContainerType;
(function (LayoutContainerType) {
    LayoutContainerType["Boxed"] = "boxed";
    LayoutContainerType["FullWidth"] = "full-width";
})(LayoutContainerType = exports.LayoutContainerType || (exports.LayoutContainerType = {}));
/**
 * @author Agnieszka Zawadzka <agnieszka.zawadzka@movecloser.pl>
 */
var LayoutSlot;
(function (LayoutSlot) {
    LayoutSlot["Bottom"] = "bottom";
    LayoutSlot["Left"] = "left";
    LayoutSlot["Main"] = "main";
    LayoutSlot["Right"] = "right";
    LayoutSlot["Top"] = "top";
    LayoutSlot["Comments"] = "comments";
})(LayoutSlot = exports.LayoutSlot || (exports.LayoutSlot = {}));
//# sourceMappingURL=content.js.map